// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3l9Aa","footer":"styles_footer__202Wj"};